import { TransitionService } from "angular-ui-router";
import moment from "moment-timezone";
import { tmh } from "./types/angular";
import { convertDateStringsToDates } from "@topline/services/convertDateStringsToDates";
import angular from "angular";
import { IdSvrAuthService } from "./auth/idSrvAuthService";
import loaderTemplate from "!!file-loader!./Components/loaderTemplate.html";
import { TokenService } from "./auth/tokenService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { TranslationCacheService } from "@topline/services/translationCacheService";

const appConfig = {
    filterMinLength: 3,
    domain: TL_ENVIRONMENT,
    version: TL_APP_VERSION,
    oidcSettings: {
        client_info_url: "/identity/clientinfo",
        isStateCheckPermissionEnabled: true,
        isSuperAdminCheck: false,
        permissionFailRedirectState: "unauthorized"
    },
    passwordPolicy: /(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.,\/#!$%\^&@\*;:{}=\-_`~()]).*/g
};

angular
    .module("topline.config")
    .run(["AppConfig", "$rootScope", (AppConfig: $TSFixMe, $root: $TSFixMe) => ($root.appConfig = AppConfig)])
    .constant("AppConfig", appConfig)
    .config([
        "tmhDynamicLocaleProvider",
        function (tmhDynamicLocaleProvider: tmh.IDynamicLocaleProvider) {
            tmhDynamicLocaleProvider.localeLocationPattern("/angular-i18n/angular-locale_{{locale}}.js");
        }
    ])
    .config([
        "$locationProvider",
        function ($locationProvider: ng.ILocationProvider) {
            $locationProvider.html5Mode(!!(window.history && window.history.pushState));
        }
    ])
    .config([
        "ChartJsProvider",
        function (ChartJsProvider: $TSFixMe) {
            ChartJsProvider.setOptions({
                chartColors: [
                    {
                        borderWidth: 3,
                        fill: false,
                        borderColor: "rgba(128, 196, 194, 1)",
                        backgroundColor: "rgba(128, 196, 194, 1)"
                    },
                    {
                        borderWidth: 3,
                        fill: false,
                        borderColor: "rgba(62, 67, 221, 0.5)",
                        backgroundColor: "rgba(62, 67, 221, 0.5)"
                    },
                    {
                        borderWidth: 3,
                        fill: false,
                        borderColor: "rgba(100,181,246, 1)",
                        backgroundColor: "rgba(100,181,246, 1)"
                    },
                    {
                        borderWidth: 3,
                        fill: false,
                        borderColor: "rgba(0,71,133, 1)",
                        backgroundColor: "rgba(0,71,133, 1)"
                    },
                    {
                        borderWidth: 3,
                        fill: false,
                        borderColor: "rgba(177, 10, 186, 1)",
                        backgroundColor: "rgba(177, 10, 186, 1)"
                    },
                    {
                        borderWidth: 3,
                        fill: false,
                        borderColor: "rgba(222, 216, 128, 1)",
                        backgroundColor: "rgba(222, 216, 128, 1)"
                    },
                    {
                        borderWidth: 3,
                        fill: false,
                        borderColor: "rgba(195, 8, 7, 1)",
                        backgroundColor: "rgba(195, 8, 7, 1)"
                    }
                ],
                legend: {
                    display: true,
                    labels: {
                        fontColor: "rgb(0, 0, 0)"
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem: $TSFixMe, data: $TSFixMe) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || "";

                            if (label) {
                                label += ": ";
                            }
                            label += tooltipItem.yLabel.toFixed(2);
                            return label.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                        }
                    }
                }
            });
        }
    ])
    .run(function () {
        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'Chart'.
        Chart.plugins.register({
            beforeDraw: function (c: $TSFixMe) {
                var ctx = c.chart.ctx;
                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, c.chart.width, c.chart.height);
            }
        });
    })
    .config([
        "$httpProvider",
        function ($httpProvider: ng.IHttpProvider) {
            ($httpProvider.defaults.transformResponse as ng.IHttpResponseTransformer[]).push(function (
                responseData: $TSFixMe
            ) {
                convertDateStringsToDates(responseData);
                return responseData;
            });
        }
    ])
    .config([
        "$translateProvider",
        function ($translateProvider: ng.translate.ITranslateProvider) {
            $translateProvider
                .useStaticFilesLoader({
                    prefix: "/resources/locale-",
                    suffix: ".json"
                })
                .useLoaderCache(TranslationCacheService.componentName)
                .preferredLanguage("pl-PL")
                .useSanitizeValueStrategy("escapeParameters")
                .useCookieStorage();
        }
    ])
    .value("cgBusyDefaults", {
        templateUrl: loaderTemplate
    })
    .run([
        IdSvrAuthService.componentName,
        function (authService: IdSvrAuthService) {
            console.log("RUN: authService.start({})");
            authService.start({});
        }
    ])
    .run([
        IdSvrAuthService.componentName,
        function (authService: IdSvrAuthService) {
            if (
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'appInsights' does not exist on type 'Win... Remove this comment to see the full error message
                window?.appInsights?.properties?.context?.user
            ) {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'appInsights' does not exist on type 'Win... Remove this comment to see the full error message
                authService.getCurrentUserLogin(login => (window.appInsights.properties.context.user.id = login));
                //= authService.getUser().Login//UserManager.user._user.Login;
            } else {
                console.log("AI user not initialized.");
            }
        }
    ])
    .run([
        "editableOptions",
        function (editableOptions: $TSFixMe) {
            editableOptions.theme = "bs3";
        }
    ])
    .run([
        "$transitions",
        "CrossMessageCommunication",
        "$timeout",
        function ($transitions: $TSFixMe, CrossMessageCommunication: $TSFixMe, $timeout: ng.ITimeoutService) {
            $transitions.onFinish({}, function (transition: $TSFixMe) {
                $timeout(function () {
                    CrossMessageCommunication.send(window.parent, "NavigatedToUrl", {
                        url: window.document.location.href
                    });
                });
            });
        }
    ])
    .run([
        "CrossMessageCommunication",
        function (CrossMessageCommunication: $TSFixMe) {
            CrossMessageCommunication.send(window.parent, "GetLanguage", {});
        }
    ])
    .config([
        "$provide",
        "$httpProvider",
        "$injector",
        function ($provide: ng.auto.IProvideService) {
            $provide.decorator("$http", [
                "$delegate",
                function ($delegate: $TSFixMe) {
                    $delegate.defaults.headers.common["X-TimeZone"] = moment.tz.guess();
                    return $delegate;
                }
            ]);
        }
    ])
    .config([
        "$urlRouterProvider",
        function ($urlRouterProvider: ng.ui.IUrlRouterProvider) {
            $urlRouterProvider.otherwise("/forecast/list");
        }
    ])
    .controller("MainController", [
        "$scope",
        "$rootScope",
        "$state",
        "CrossMessageCommunication",
        "LocaleService",
        "$window",
        IdSvrAuthService.componentName,
        "$transitions",
        "$q",
        angularServicesNames.$translate,
        function (
            $scope: $TSFixMe,
            $rootScope: ng.IRootScopeService,
            $state: ng.ui.IStateService,
            CrossMessageCommunication: $TSFixMe,
            LocaleService: $TSFixMe,
            $window: ng.IWindowService,
            authService: IdSvrAuthService,
            $transitions: TransitionService,
            $q: ng.IQService,
            $translate: ng.translate.ITranslateService
        ) {
            authService.getCurrentUserProfile().then(user => ($scope.currentUser = user)); // UserManager.user._user;

            $scope.languageCulture = {};

            $scope.isHostedInBpm = $window !== $window.parent;

            function convertLanguage(language: $TSFixMe) {
                var _language = language.toLowerCase();
                if (_language === "pl") {
                    $scope.languageCulture = _language + "-PL";
                } else {
                    $scope.languageCulture = _language + "-US";
                }
            }

            $transitions.onStart({}, function (transition: $TSFixMe) {
                if (transition.to().resolve) {
                    if ($scope.defer && $scope.defer.promise.$$state.status == 0) $scope.defer.resolve();
                    $scope.defer = $q.defer();
                    $scope.stateTransitionPromise = $scope.defer.promise;
                }
            });

            $transitions.onSuccess({}, function (transition: $TSFixMe) {
                if ($scope.defer) $scope.defer.resolve();
            });

            CrossMessageCommunication.receive({
                LanguageChanged: function (language: $TSFixMe) {
                    convertLanguage(language);
                    const triggerEvent = $translate.use() != $scope.languageCulture;
                    LocaleService.setLocaleByDisplayName(language);
                    if (triggerEvent) {
                        $rootScope.$broadcast("LanguageChanged");
                    }
                },
                NavigateToUrl: function (url: $TSFixMe) {
                    var state = getStateFromUrl(url);
                    $state.go(state!.name!);
                }
            });

            function getStateFromUrl(url: $TSFixMe) {
                var l = document.createElement("a");
                l.href = url;

                var states = $state
                    .get()
                    .filter((state: $TSFixMe) => state.$$state().url && state.$$state().url.exec(l.pathname));
                if (states.length == 0) return null;
                return states[0];
            }

            if (jQuery) {
                jQuery.ajaxSetup({
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    }
                });
            }
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'LoggedUser' does not exist on type 'Docu... Remove this comment to see the full error message
            $scope.LoggedUser = document.LoggedUser;
        }
    ])
    .config([
        "$provide",
        "$httpProvider",
        function ($provide: ng.auto.IProvideService, $httpProvider: ng.IHttpProvider) {
            $provide.decorator("synchronousEventsBus", [
                "$delegate",
                "$q",
                "$log",
                function $synchronousEventsBusDecorator($delegate: $TSFixMe, $q: ng.IQService, $log: ng.ILogService) {
                    var originalBroadcast = $delegate.$broadcast;
                    $delegate.$broadcast = function decoratedBroadcast(eventName: $TSFixMe, args: $TSFixMe) {
                        $log.debug("$broadcast was called on synchronousEventsBus with event: " + eventName);
                        return originalBroadcast.apply($delegate, arguments);
                    };

                    var originalOn = $delegate.$on;
                    $delegate.$on = function decoratedOn(eventName: $TSFixMe, callback: $TSFixMe) {
                        $log.debug("$on was called on synchronousEventsBus with event: " + eventName);
                        return originalOn.apply($delegate, arguments);
                    };

                    return $delegate;
                }
            ]);

            $httpProvider.interceptors.push([
                "$q",
                IdSvrAuthService.componentName,
                TokenService.componentName,
                ($q: ng.IQService, authService: IdSvrAuthService, tokenService: TokenService) => ({
                    request: (config: any) => {
                        const token = tokenService.accessToken;
                        if (token) {
                            config.headers["Authorization"] = `Bearer ${token}`;
                        }

                        return config;
                    },
                    responseError: function (rejection) {
                        // if (rejection.status === 401) {
                        //     authService.signIn();
                        // }
                        return $q.reject(rejection);
                    }
                })
            ]);
        }
    ])
    .config([
        "$cookiesProvider",
        "$windowProvider",
        "AppConfig",
        function ($cookies: $TSFixMe, $windowProvider: $TSFixMe, AppConfig: $TSFixMe) {
            var $window = $windowProvider.$get();
            if ($window.location.hostname != "localhost" && $window.location.hostname != "127.0.0.1") {
                $cookies.defaults.domain = AppConfig.domain;
            }
        }
    ]);
